import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getSideBarfilesActions,
  settheQuerySubQuestionActions,
  setTheQuerySUbQuestionsDeleteActions, ///delete
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import QueryActions from "./QueryActions";
import SubQueryActions from "./SubQueryActions";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";


const SubQuerys = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [EditId, setEditID] = useState();

  const [ParentId, setParentid] = useState(state.NeededdatasListed.SubQueryIDs);

  useEffect(() => {
    const payload = {
      search: search,
      page_size: dtpagesize,
      page: dtpageindex,
      parent: state.NeededdatasListed.SubQueryIDs,
    };
    dispatch(settheQuerySubQuestionActions(payload));
  }, [dtpageindex, dtpagesize]);
  console.log(state.QueryQuetionsDatas, "QueryQuetionsDatas");

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: dtpagesize,
          page: 1,
          parent: state.NeededdatasListed.SubQueryIDs,
        };
        dispatch(settheQuerySubQuestionActions(payload));
      }, 500),
    []
  );

  function tochange(e) {
    setsearch(e);
    debouncedSearch(e);
    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesize,
    //     page: 1,
    //     parent: state.NeededdatasListed.SubQueryIDs,
    //   };
    //   dispatch(settheQuerySubQuestionActions(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //     parent: state.NeededdatasListed.SubQueryIDs,
    //   };
    //   dispatch(settheQuerySubQuestionActions(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const columns = [
    {
      Header: "Ticktes",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.name ? (
              <span>{row.row.original.name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Expire Date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.expire_time ? (
              <span>{row.row.original.expire_time}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.description ? (
              <span>{row.row.original.description}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original != undefined &&
            row.row.original.id != undefined &&
            row.row.original.parent_id != undefined &&
            row.row.original.parent_id.id != undefined ? (
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                <button
                  className=" btn Status"
                  onClick={(e) => {
                    setParentid(row.row.original.parent_id.id);
                    setEditID(row.row.original.id);
                    setRoleCreatePopup(true);
                  }}
                  component="span"
                >
   <span className="OuterActionSpan">
            
                   <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
                </button>

                <button
                  type="button"
                  class="btn Status"
                  onClick={(e) => {
                    setDeleteID(row.row.original.id);
                    setDeletePOPUP(true);
                  }}
                >
                <span className="OuterActionSpan">
                
                  <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
                </button>
              </div>
            ) : null}
          </>
        );
      },
    },
  ];

  const HandleDeletes = () => {
    if (DeleteID != undefined) {
      console.log(currentPage, "sdsd");
      const payload = {
        DeleteId: DeleteID,
        currentPage: dtpageindex,
        parent_id: state.NeededdatasListed.SubQueryIDs,
      };
      dispatch(
        setTheQuerySUbQuestionsDeleteActions(payload, setDeletePOPUP(false))
      );
    }
  };

  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3> Ticket Subcategory </h3>
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <NavLink
                  style={{ textDecoration: "none", color: "#333333" }}
                  to={"/ticketcategory"}
                >
                  Ticket Category
                </NavLink>
              </li>

              <li class="breadcrumb-item"> Ticket Sub Category</li>
            </ul> */}
          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setRoleCreatePopup(true);
                setEditID("");
              }}
              className="ButtonCSS"
            >
              {" "}
              {/* Create Ticket */}
              Create
            </button>
          </div>
        </div>

        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/ticketcategory");
              }}
            >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>
            </button>
          </div>
        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.QuerySubQuetionsDatas.QuerySubQuestionsDatas}
            columns={columns}
            totalItems={state.QuerySubQuetionsDatas.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            datacount={state.QuerySubQuetionsDatas.Total_Count}
            Filter={true}
            NoFilter ={true}


          />
        </div>
      </div>

      {RoleCreatePopup && EditId == "" ? (
        <SubQueryActions
          setShow={setRoleCreatePopup}
          show={RoleCreatePopup}
          currentPage={dtpageindex}
          EditID={EditId}
          ParentId={ParentId}
          search={search}
        />
      ) : null}

      {RoleCreatePopup && EditId != "" ? (
        <SubQueryActions
          setShow={setRoleCreatePopup}
          show={RoleCreatePopup}
          currentPage={dtpageindex}
          EditID={EditId}
          search={search}
          ParentId={ParentId}
        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandleDeletes}
          Content={"Do you want to delete the Ticket Subcategory"}

        />
      ) : null}
    </>
  );
};

export default SubQuerys;
